module.exports = __webpack_public_path__ + "img/icon_mail.2ff91583.png";